import {
  CustomerDetailsFragment,
  CustomerThreeYearsStatistics,
} from "@/gql/graphql";
import { routeFactory } from "@/RouteFactory";
import {
  Card,
  CardBody,
  CardHeader,
  FlatButton,
  stenaExternalLink,
  stenaStatisticsBar,
} from "@stenajs-webui/elements";
import { StandardTable } from "@stenajs-webui/grid";
import * as React from "react";
import { useNavigate } from "react-router";
import {
  customerThreeYearStatisticsTableConfig,
  ThreeYearsTableRow,
} from "./CustomerThreeYearStatisticsTableConfig";
import { usecustomerThreeYearsStatistics } from "@/features/product-and-price/hooks/UseCustomerThreeYearStatistics";

interface Props {
  currencyCode: string;
  customerId: string;
}

export const CustomerThreeYearStatisticsInfoBox: React.FC<Props> = ({
  currencyCode,
  customerId,
}) => {
  const navigate = useNavigate();

  const { loading, threeYearsStatistics } = usecustomerThreeYearsStatistics(
    customerId,
    currencyCode
  );

  const transformThreeYearStatisticsToTableRow = (
    customerStatistics: CustomerThreeYearsStatistics[],
    currencyCode: string
  ): Array<ThreeYearsTableRow> => {
    return customerStatistics.map((statistic) => {
      return {
        actualRate: statistic.actualRate,
        diffPrevYear: statistic.diffPreviousYear,
        expVolume: statistic.expectedVolume,
        last12MonthsVolume: statistic.last12MonthsVolume,
        negotiationStatus: statistic.negotiationStatus,
        pricePerMeter: statistic.pricePerMeter,
        targetRate: statistic.targetRate,
        year: statistic.year,
        currencyCode,
      };
    });
  };

  return (
    <Card>
      <CardHeader
        text={"Statistics"}
        leftIcon={stenaStatisticsBar}
        contentRight={
          <FlatButton
            leftIcon={stenaExternalLink}
            onClick={() =>
              navigate(routeFactory.statistics.customerDetails(customerId))
            }
            title={"Go to customer statistics"}
          />
        }
      />
      <CardBody overflow={"auto"}>
        <StandardTable
          items={transformThreeYearStatisticsToTableRow(
            threeYearsStatistics || [],
            currencyCode
          )}
          loading={loading}
          config={customerThreeYearStatisticsTableConfig}
          noItemsLabel={"No customer statistics found."}
        />
      </CardBody>
    </Card>
  );
};
